import { useState, useEffect } from 'react';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';

const rows = [10, 20, 30, 50, 100];

const PaginationChangeRange = ({ value, setValue }) => {
  const [limits, setLimits] = useState(() => {
    return rows.includes(value) ? rows : [...rows, value].sort((a, b) => a - b);
  });

  useEffect(() => {
    if (!limits.includes(value)) {
      setLimits((prev) => [...prev, value].sort((a, b) => a - b));
    }
  }, [value, limits]);

  const handleChangeValue = (event) => {
    const newValue = Number(event.target.value);
    if (newValue !== value && setValue) {
      setValue(newValue);
    }
  };

  return (
    <Select size="small" value={value} onChange={handleChangeValue} sx={{ minWidth: 80 }}>
      {limits.map((limit) => (
        <MenuItem key={limit} value={limit}>
          {limit}
        </MenuItem>
      ))}
    </Select>
  );
};

export default PaginationChangeRange;
